import DataProvider from '@/api/DataProvider';
import HttpAdapter from '@/api/adapters/HttpAdapter';
import resources from './resources';
import httpClient from '@/api/httpClient';
import getEnvVariable from '@/utils/getEnvVariable';
import store from '@/store';

const baseURL = getEnvVariable('VUE_APP_NOTIFICATION_API_URL');
const beforeRequestInterceptor = ({ requestConfig }) => ({
    ...requestConfig,
    headers: {
        'X-Quext-Customer-Id': store.getters['auth/customerId'],
    },
});

const httpAdapter = new HttpAdapter(httpClient(baseURL), resources, beforeRequestInterceptor);

export default new DataProvider(httpAdapter);
